import type { ReactNode } from 'react';
import { ShowcaseSection } from './ShowcaseSection';

interface ShowcaseDemoSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export function ShowcaseDemoSection({
  title,
  description,
  children,
}: Readonly<ShowcaseDemoSectionProps>) {
  return (
    <ShowcaseSection title={title} description={description}>
      {children}
    </ShowcaseSection>
  );
}
